/** @jsxImportSource @emotion/react */
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

import { css } from '@emotion/react'
import { BoxStore } from '../../stores/RussianPoker/Box.store'
import { SeatBtnBox } from './SeatBtnBox'
import { SeatNumberBox } from './SeatNumberBox'
import {
  BetWrapper,
  Container,
  ContainerWrapper,
  Inside,
  StyledAnte,
  StyledBet,
  StyledBonus,
} from './styles'

export const InitialBoxView: FC<{ box: BoxStore }> = observer((props) => {
  const { seatNumber, sendSelectedBox } = props.box

  return (
    <ContainerWrapper>
      <Container>
        <Inside>
          <SeatNumberBox seatNumber={seatNumber} />
          <SeatBtnBox
            data-cy={`rp-take-box-btn-${seatNumber}`}
            onClick={() => {
              sendSelectedBox()
            }}
            css={css`
              position: absolute;
              width: 100%;
              height: 100%;
            `}
          />
          <BetWrapper>
            <StyledBonus selected={false} />
            <StyledAnte selected={false} />
            <StyledBet selected={false} />
          </BetWrapper>
        </Inside>
      </Container>
    </ContainerWrapper>
  )
})
